import { useEffect, useState } from 'react';
const UPDATE_INTERVAL_PRESET_MS = {
    'one-minute': 60_000,
    'one-second': 1_000,
};
function getUpdateIntervalMs(updateInterval) {
    if (typeof updateInterval === 'string')
        return UPDATE_INTERVAL_PRESET_MS[updateInterval];
    return updateInterval.value;
}
/**
 * Returns the current wall-clock time and refreshes it on a fixed interval.
 * The interval is cleared when the consuming component unmounts.
 *
 * @returns The clock value captured at mount or at the latest interval tick.
 *
 * @example
 * // Assume the component mounts at 2026-07-24T12:00:00.000Z.
 * const currentTime = useCurrentTime();
 * currentTime.toISOString(); // '2026-07-24T12:00:00.000Z'
 *
 * // After the wall clock advances one hour and the next interval fires:
 * currentTime.toISOString(); // '2026-07-24T13:00:00.000Z'
 *
 * // After the wall clock advances another 27 hours and the next interval fires:
 * currentTime.toISOString(); // '2026-07-25T16:00:00.000Z'
 */
export function useCurrentTime({ initialTime, updateInterval } = { updateInterval: 'one-minute' }) {
    const [currentTime, setCurrentTime] = useState(() => initialTime ?? new Date());
    const updateIntervalMs = getUpdateIntervalMs(updateInterval);
    useEffect(() => {
        const intervalId = window.setInterval(() => {
            setCurrentTime(new Date());
        }, updateIntervalMs);
        return () => {
            window.clearInterval(intervalId);
        };
    }, [updateIntervalMs]);
    return currentTime;
}
//# sourceMappingURL=useCurrentTime.js.map